import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { AppointmentResponseDto } from '../../../../types/appointment.types';

interface Props {
  target: AppointmentResponseDto | null;
  completing: boolean;
  onConfirm: (expertNotes: string) => void;
  onClose: () => void;
}

export const ExpertAppointmentCompleteDialog: React.FC<Props> = ({ target, completing, onConfirm, onClose }) => {
  const [notes, setNotes] = useState('');

  // C5: ініціалізуємо існуючими нотатками. Без цього експерт, який натиснув "Завершити"
  // не торкаючись поля, надсилав би '' → бек трактував би це як експліцитне очищення.
  useEffect(() => {
    setNotes(target?.expertNotes ?? '');
  }, [target]);

  return (
    <Dialog open={target !== null} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Завершити зустріч</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          multiline
          rows={4}
          margin="dense"
          label="Нотатки експерта (необов'язково)"
          value={notes}
          onChange={e => setNotes(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={completing}>Відміна</Button>
        <Button color="success" variant="contained" onClick={() => onConfirm(notes)} disabled={completing}>
          Завершити
        </Button>
      </DialogActions>
    </Dialog>
  );
};
